import {
  Autocomplete,
  FormHelperText,
  TextField,
  IconButton,
  Icon,
} from "@mui/material";
import { t } from "i18next";
import "./BMXAutocompleteSecretary.scss";

export default function BMXAutocompleteSecretary(props) {
  const {
    meta: { touched, error, submitError } = {},
    input = {},
    afterIcon,
    afterIconSize,
    afterIconClick,
    disabled,
    options = [],
    renderValue,
    getOptionLabel: customGetOptionLabel,
    renderSecondary,
    filterOptions: customFilterOptions,
    onInputChange: customOnInputChange,
    ...restProps
  } = props;

  const isError = () => !!((error || submitError) && touched);

  const onChange = (event, option) => {
    input.onChange(option);
  };

  const resolveLabel = (option) => {
    if (!option) return "";
    if (typeof option === "string") return option;
    if (customGetOptionLabel) return customGetOptionLabel(option);
    return renderValue ? renderValue(option) : option.label || "";
  };

  const safeValue = input.multiple
    ? Array.isArray(input.value)
      ? input.value
      : []
    : input.value ?? null;

  return (
    <Autocomplete
      data-cy="autocomplete-select"
      {...restProps}
      options={options}
      multiple={Boolean(input?.multiple)}
      disableCloseOnSelect={Boolean(input?.multiple)}
      value={safeValue}
      disabled={disabled}
      onChange={onChange}
      onInputChange={(event, newInputValue, reason) => {
        if (customOnInputChange) {
          customOnInputChange(event, newInputValue, reason);
        }
      }}
      noOptionsText={t("global:no_values")}
      isOptionEqualToValue={(option, value) => {
        if (!option || !value) return false;
        if (typeof option === "string" || typeof value === "string") {
          return option === value;
        }
        if (option.uuid && value.uuid) return option.uuid === value.uuid;
        if (option.id && value.id) return option.id === value.id;
        return option === value;
      }}
      getOptionLabel={resolveLabel}
      filterOptions={(optionsList, state) => {
        if (customFilterOptions) {
          return customFilterOptions(optionsList, state);
        }
        const search = state.inputValue.toLowerCase().trim();
        if (!search) return optionsList;

        return optionsList.filter((option) => {
          const text = resolveLabel(option).toLowerCase();
          return text.includes(search);
        });
      }}
      renderOption={(liProps, option) => {
        const { key, ...restLiProps } = liProps;
        const optionKey =
          key || option?.uuid || option?.id || resolveLabel(option);

        return (
          <li key={optionKey} {...restLiProps}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              {resolveLabel(option)}
              {renderSecondary && (
                <div style={{ fontSize: "0.8rem", opacity: 0.7 }}>
                  {renderSecondary(option)}
                </div>
              )}
            </div>
          </li>
        );
      }}
      renderInput={(params) => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            className="InputArea"
            style={{
              display: "flex",
              alignItems: "flex-end",
              width: "100%",
            }}
          >
            <TextField
              {...params}
              variant="standard"
              error={isError()}
              style={{ flex: 1 }}
            />

            {afterIcon && (
              <IconButton
                size="small"
                disabled={disabled}
                onClick={afterIconClick}
                disableRipple={!afterIconClick}
                style={{
                  marginBottom: "4px",
                  padding: 4,
                }}
              >
                <Icon style={{ fontSize: afterIconSize }}>{afterIcon}</Icon>
              </IconButton>
            )}
          </div>

          {isError() && (
            <FormHelperText error style={{ margin: 0 }}>
              <span className="error text">{error || submitError}</span>
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}
